export class VideoMetadata {
  public videoTitle: string;
  public date: Date | null;
  public language: string;
  public contentType: string;
  public location: string;
  public copyright: string;
  public description: string;
  public altText: string;

  constructor(data: any = {}) {
    this.videoTitle = data?.videoTitle ?? '';
    this.date = data?.date ? new Date(data?.date) : null;
    this.language = data?.language ?? '';
    this.contentType = data?.contentType ?? '';
    this.location = data?.location ?? '';
    this.copyright = data?.copyright ?? '';
    this.description = data?.description ?? '';
    this.altText = data?.altText ?? '';
  }

  public static createFromApi(data: any = {}): VideoMetadata {
    return new VideoMetadata(data);
  }

  public processForApi(): Record<string, any> {
    return {
      ...this,
      date: this.date instanceof Date ? this.date.toJSON() : null,
    };
  }
}
